<template>
  <v-app id="inspire"> 
     <v-app-bar
    id="app-bar"
    fixed
    clipped-left
    app
    color="darken-3"
    dark 
    dense
    height="64"  
  > 
    <v-app-bar-nav-icon 
      medium
      class="pl-10"
      color="white darken-1" 
    ><v-img src="/ntsa.png" height="60" width="100"/></v-app-bar-nav-icon>   

    <v-spacer></v-spacer>   
 
   <!-- <router-link to="/violations">
    <v-btn
      class="ml-2"
      color="white" 
      min-width="0" 
      text> 
      <v-icon medium>mdi-alert-outline</v-icon> Violations Report
    </v-btn> 
    </router-link> -->

    <v-btn
      class="ml-2"
      color="white"
      @click="logout" 
      min-width="0"
      text
    >
      <v-icon medium>mdi-exit-to-app</v-icon> Sign Out
    </v-btn> 
    <br />
  </v-app-bar>

  <div style="min-height:610px; background: #eee"  class="mobile_content">
         
        <v-row>
          <v-col cols="3"></v-col>
          <v-col>
            <v-text-field
            v-model="search" 
            color="green"
            flat
            solo-inverted
            class="mt-7"
            label="Search Vehicle"
            prepend-inner-icon="mdi-magnify" 
          ></v-text-field>    
          </v-col>
          <v-col cols="1"><v-btn class="mt-8" @click="available_data" :loading="loading"><v-icon>mdi-magnify</v-icon></v-btn></v-col>
          <v-col cols="3"></v-col>
        </v-row>

         <Notification></Notification>

         <div ref='content'>
 
         <v-row>
           <v-col>
             <v-simple-table class="pa-1">
               <thead> <tr><th>Owner Details</th></tr> </thead>
               <tbody>
                 <tr><td>Name  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.owner}}</b></td></tr>
                 <tr><td>ID No. &nbsp;&nbsp;&nbsp;&nbsp; <b>{{  movements.id}}</b></td></tr>
                 <tr><td>Phone No. &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.phone}}</b></td></tr> 
               </tbody>
             </v-simple-table> 
           </v-col>

           <v-col>
             <v-simple-table class="pa-1">
               <thead> <tr><th>Asset Details</th></tr> </thead>
               <tbody>
                 <tr><td>Registration No.  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.regno}}</b></td></tr>
                 <tr><td>Chassis No.  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.chassis}}</b></td></tr>
                 <tr><td>Limiter Type  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.limitertype}}</b></td></tr> 
                 <tr><td>Limiter Serial &nbsp;&nbsp;&nbsp; &nbsp; <b>{{movements.limiterserial}}</b></td></tr> 
                 <tr><td>Make &amp; Model   &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.make}}</b></td></tr> 
               </tbody>
             </v-simple-table>  
           </v-col>

           <v-col>
             <v-simple-table class="pa-1">
               <thead> <tr><th>Fitting Company</th></tr> </thead>
               <tbody>
                 <tr><td>Name &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.fittingcenter}}</b></td></tr>
                 <tr><td>Business Reg No. &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.bsnreg}}</b></td></tr>
                 <tr><td>Phone No.&nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentphoneno}}</b></td></tr> 
                 <tr><td>Email&nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentemail}}</b></td></tr> 
               </tbody>
             </v-simple-table>  
           </v-col>

           <v-col>
             <v-simple-table class="pa-1" dense style="font-size: 9px">
               <thead> <tr><th>Fitting Agent Details</th></tr> </thead>
               <tbody>
                 <tr><td>Name  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.fittingcenter}}</b></td></tr>
                 <tr><td>ID Number  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentid}}</b></td></tr>
                 <tr><td>Phone Number  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.agentphoneno}}</b></td></tr> 
                 <tr><td>Date Of Fitting  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.installdate}}</b></td></tr> 
                 <tr><td>Certificate Number  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.serialno}}</b></td></tr> 
                 <tr><td>Name &amp; Location of Station  &nbsp;&nbsp;&nbsp;&nbsp; <b>{{movements.location}}</b></td></tr> 
               </tbody>
             </v-simple-table>  
           </v-col> 
         </v-row> 
        <br>  

        <v-container> 
           <v-row> 
            <v-col md="6"><v-btn color="green" :loading="loading" v-if="recs_loading" ><v-icon>mdi-refresh</v-icon> Refreshing....</v-btn></v-col>
            <v-col  md="4">
              <v-btn-toggle v-model="toggle_none" background-color="primary"> 
                      <v-btn value="current">Current</v-btn>  
                      <v-btn value="overspeed">Overspeed</v-btn>  
                      <v-btn value="violations">Violations</v-btn>   
                </v-btn-toggle>  
            </v-col>
            <v-col md="2">
              <v-select
                  v-model="toggle_export_none"
                  :items="[{id: 'opt',name:'Download Options'},{id: 'lastone',name:'Last 1 Hour'}, {id: 'lasttwentyfour',name:'Last 6 Hours'},{id: 'lastseventytwo',name:'Last 72 Hours'},{id: 'download',name:'Download Displayed'}]"
                  label="Export Options"
                  item-value='id'
                  item-text='name'
                  outlined
                  @change="initDownload(search)" 
                ></v-select>
            </v-col>
          </v-row>
        </v-container>

        <v-simple-table class="pa-1">
               <thead> <tr> <th>Date</th>  <th>Speed</th> <th>Longitude</th> <th>Latitude</th> </tr> </thead>
               <tbody>
                 <!-- <tr v-if="recs_loading"><td colspan="5">Populating records please wait..</td> </tr>  -->
                 <tr v-if="!recs_loading && recs.length==0"><td colspan="5">No records found.</td> </tr> 
                 <tr v-for="(drive,index)  in recs" :key="index">
                   <td>{{drive.dt_tracker}}</td>  <td>{{drive.speed}}</td> <td>{{drive.lng}}</td> <td>{{drive.lat}}</td>
                 </tr>
               </tbody>
        </v-simple-table>  
         </div>
  </div>  
  <Footer /> 
  </v-app>
</template>

<style scoped>
body {
  background: #eee;
  font-family: "Open Sans", Arial, Helvetica, sans-serif;
  font-size: 12px;
}

.theme--light.v-application{
  background: #eee
}

.mobile_content{
  margin-left: 0  !important;
  padding: 3px !important;
  padding-top: 63px !important;
} 
</style>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import common from "./mixins/common";
import vue from "vue";
import jsPDF from "jspdf"; 

export default {
  name: "Ntsa",
  components: { 
    Footer: () => import("./components/Footer"),
    Notification: () => import("./components/Notification")
  },  
  mixins: [common], 
  methods: {  
    logout() {
      this.$store.dispatch("logout");
    }, 

    available_data() {
      if(this.search==''){
         this.setNotification(
              "error",
              "Search for an asset to continue."
            );
        return;
      }

      this.loading = true;
      this.http_connect("/sg",{ token: this.check_token(), country: process.env.VUE_APP_COUNTRY, regno: this.search  })
        .then(res => {  
          if (res.status == 200) { 
            if(res.data.payload.sg.length > 0 ){
              this.movements = res.data.payload.sg[0];   
              this.checkdata();
            } 
            // else 
            //  this.setNotification(
            //   "error",
            //   "Asset is not available."
            // );
          } else {
            // this.setNotification(
            //   "error",
            //   "Failed to fetch records please try again."
            // );
            this.loading = false;
          }
          this.loading = false;
        })
        .catch(err => {
          // this.setNotification("error", "Failed to fetch vehicle details.");
          this.loading = false;
        });
    },

    initDownload(source){  
       this.hasreset = true 
       //{id: 'opt',name:'Select Download Options'},{id: 'current',name:'Current'},{id: 'lastone',name:'Last 1 Hour'}, 
       //{id: 'lasttwentyfour',name:'Last 6 Hours'},{id: 'lastseventytwo',name:'Last 72 Hours'},{id: 'download'
       if(this.toggle_export_none !='opt'  ){ 
          if(this.toggle_export_none =='download' ){
             this.$nextTick(() => {
              if(!this.downloading) 
                this.download(source)
              else
                alert("Another process is already running. Please wait for download to complete.")
            }); 
          } else {
            this.download_after_loading = true; 
            this.toggle_none = this.toggle_export_none
          }
      }
    },
 
    download(source) {
      if(source ==""){
          alert("Search an asset to continue.");
          return;
      }

      this.downloading = true;
      const doc = new jsPDF(); 
      doc.setFontSize(12);
      doc.addImage("http://ntsa.kensrin.co.ke/favicon.png", "JPEG",10, 0, 30, 30);

      doc.setFont("times", "bold");
      doc.text("Owner Details", 10, 40);
      doc.setFont("times", "normal");

      doc.text("Owner Name : "+ this.movements.owner, 10, 50);
      doc.text("Owner ID  : "+ this.movements.id, 10, 60);
      doc.text("Owner Phone : "+ this.movements.phone , 10,70);

      doc.setFont("times", "bold");
      doc.text("Asset Details:", 10, 80);
      doc.setFont("times", "normal");
      
      doc.text("Registration : "+ this.movements.regno, 10, 90);
      doc.text("Chassis : "+ this.movements.chassis, 10, 100);
      doc.text("Make & Model : "+ this.movements.make, 10, 110);
      doc.text("Limiter Type : "+ this.movements.limitertype, 10, 120);
      doc.text("Limiter Serial : "+ this.movements.limiterserial, 10, 130);

      doc.setFont("times", "bold");
      doc.text("Fitting Center:", 10, 140);
      doc.setFont("times", "normal");

      doc.text("Center Name : "+ this.movements.fittingcenter, 10, 150);
      doc.text("Business Reg No. : "+ this.movements.bsnreg, 10, 160);
      doc.text("Center Phone No. : "+ this.movements.agentphoneno, 10, 170);
      doc.text("Center Email     : "+ this.movements.agentemail, 10, 180);

      doc.setFont("times", "bold");
      doc.text("Installatin Details", 10, 190);
      doc.setFont("times", "normal");

      doc.text("Fitting Date  :  "+ this.movements.installdate, 10, 200);
      doc.text("Certificate No. : "+ this.movements.serialno, 10, 210);
      doc.text("Fitting Location : "+ this.movements.location, 10, 220); 

      doc.setFont("times", "italic");
      doc.setFontSize(11);
      doc.text("{records on the next page}", 105, 250, null, null, "center");
      doc.setFont("times", "normal");
      doc.setFontSize(12);
      doc.addPage()
      var data =[];
      var title = ["Date","Speed","Longitude","Latitude"];  
      for (var i = 0; i < this.recs.length; i += 1) { 
        data.push({id: (i + 1).toString(), Date: this.recs[i].dt_tracker, Speed: this.recs[i].speed,Longitude: this.recs[i].lng, Latitude: this.recs[i].lat });
      }  
      doc.table(1, 1, data, this.createHeaders(title), { autoSize: false });
      doc.save(source +"_report.pdf");
      this.downloading = false;  
    },

    createHeaders(keys) {
      var result = [];
      for (var i = 0; i < keys.length; i += 1) {
        result.push({
          id: keys[i],
          name: keys[i],
          prompt: keys[i],
          width: 65,
          align: "center",
          padding: 0
        });
      }
      return result;
    },
 
    checkdata(){ 
      this.recs_loading = true;
      this.http_connect("/get_route_ntsa", {
        token: this.check_token(), 
        speed: this.toggle_none=="overspeed"? '80' : (this.toggle_none=="violations"? 'violations'  :''),
        hours: this.toggle_none=="current"? '' : ( this.toggle_none=="lasttwentyfour"? '6' : (this.toggle_none=="lastseventytwo"? '72':"1")  ),
        imei:  this.movements.imei
      }).then(res => {  
        this.recs = res.data;
        this.recs_loading = false; 
        this.initial_load = true;
        this.last_load_complete = true;
 

        if(this.download_after_loading){
           if(!this.downloading) 
                this.download(this.movements.regno);
            else
                alert("Another process is already running. Please wait for download to complete.") 
            this.download_after_loading = false;
        }

        if(this.interval!="")
          clearInterval(this.interval);

        this.interval =  window.setInterval(() => { 
           if(this.last_load_complete){
             this.last_load_complete = false;
              this.checkdata();
           }
          }, 60000);  
      });  
    }, 
  },

  watch: {
        toggle_none: function () {
            if(this.initial_load && this.search !='')
              this.checkdata();
        },
  },
 
  data: () => ({
    loading: false,
    recs_loading: false,
    search: '',
    movements: [],
    recs: [],
    toggle_none: 'current',
    toggle_export_none: 'opt',
    initial_load: false,
    last_load_complete: false,
    hasreset : false, 
    downloading: false, 
    download_after_loading: false,
    interval: ''
  })
};
</script>